import { get, post, del } from '../api.js';
import { setTopbar, lucideIcons, esc } from '../app.js';
import { confirmDialog } from '../dialog.js';
import { toast } from '../dialog.js';
import { relTime } from '../utils.js';

export async function renderDeadDropManage(container) {
  setTopbar('Dead Drop Inboxes', '');
  container.innerHTML = '<p class="loading">Loading...</p>';

  try {
    const inboxes = await get('/dead-drop-inboxes');
    render(container, inboxes);
  } catch (err) {
    container.innerHTML = `<div class="msg msg-error">${esc(err.message)}</div>`;
  }
}

function render(container, inboxes) {
  let html = `
    <div class="section-title">Create Inbox</div>
    <div class="card" style="margin-bottom:24px">
      <p style="color:var(--text-secondary);font-size:13px;margin-bottom:12px">
        Create a dead drop inbox to receive encrypted files from anyone. Share the URL on your website, business card, or messaging app.
      </p>
      <form id="create-inbox-form" style="display:flex;flex-direction:column;gap:12px">
        <div class="field">
          <label>Label <span style="color:var(--text-secondary);font-weight:400">(optional)</span></label>
          <input type="text" name="label" placeholder="e.g. Tip Line, Legal Docs" maxlength="100">
        </div>
        <div class="field">
          <label>Custom Slug <span style="color:var(--text-secondary);font-weight:400">(optional)</span></label>
          <input type="text" name="slug" placeholder="e.g. tips" pattern="[a-z0-9][a-z0-9-]*" minlength="3" maxlength="63">
          <p style="font-size:12px;color:var(--text-secondary);margin-top:4px">Lowercase letters, digits, and hyphens. 3-63 chars. Leave blank for a UUID URL.</p>
        </div>
        <div id="create-msg"></div>
        <button type="submit" class="btn btn-primary btn-sm" style="align-self:flex-start">Create Inbox</button>
      </form>
    </div>
  `;

  html += '<div class="section-title">Active Inboxes</div>';

  if (inboxes.length === 0) {
    html += '<p style="color:var(--text-secondary)">No active inboxes yet.</p>';
  } else {
    for (const inbox of inboxes) {
      const url = inboxUrl(inbox);
      html += `
        <div class="card" style="margin-bottom:12px">
          <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px">
            <div style="flex:1;min-width:0">
              <div style="font-weight:600;color:var(--text-primary,#fff);margin-bottom:4px">${esc(inbox.label || '(no label)')}</div>
              <div style="font-size:12px;color:var(--text-secondary);margin-bottom:8px">Created ${relTime(inbox.created_at)}</div>
              <div class="copy-link-row">
                <input value="${esc(url)}" readonly class="inbox-url-input" data-id="${inbox.id}" style="font-size:13px">
                <button class="btn btn-secondary btn-sm copy-inbox-url" data-url="${esc(url)}">Copy</button>
              </div>
            </div>
            <button class="btn btn-danger btn-sm deactivate-inbox" data-id="${inbox.id}" title="Deactivate"><i data-lucide="trash-2" style="width:14px;height:14px"></i></button>
          </div>
        </div>
      `;
    }
  }

  container.innerHTML = html;
  lucideIcons();

  // Create inbox form
  document.getElementById('create-inbox-form').onsubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const btn = form.querySelector('button[type="submit"]');
    const msgEl = document.getElementById('create-msg');
    const slug = form.slug.value.trim().toLowerCase() || undefined;
    const label = form.label.value.trim() || undefined;

    btn.disabled = true;
    btn.textContent = 'Creating...';
    msgEl.innerHTML = '';

    try {
      await post('/dead-drop-inboxes', { slug, label });
      const updated = await get('/dead-drop-inboxes');
      render(container, updated);
      toast('Inbox created', 'success');
    } catch (err) {
      msgEl.innerHTML = `<div class="msg msg-error">${esc(err.message)}</div>`;
      btn.disabled = false;
      btn.textContent = 'Create Inbox';
    }
  };

  // Copy URL buttons
  container.querySelectorAll('.copy-inbox-url').forEach(btn => {
    btn.onclick = () => {
      navigator.clipboard.writeText(btn.dataset.url).then(() => {
        btn.textContent = 'Copied!';
        setTimeout(() => { if (btn) btn.textContent = 'Copy'; }, 2000);
      });
    };
  });

  // Deactivate buttons
  container.querySelectorAll('.deactivate-inbox').forEach(btn => {
    btn.onclick = async () => {
      if (!await confirmDialog('Deactivate this inbox? Senders will no longer be able to upload.', { danger: true })) return;
      try {
        await del(`/dead-drop-inboxes/${btn.dataset.id}`);
        const updated = await get('/dead-drop-inboxes');
        render(container, updated);
        toast('Inbox deactivated', 'success');
      } catch (err) {
        toast('Failed: ' + err.message);
      }
    };
  });
}

function inboxUrl(inbox) {
  const base = window.location.origin + window.location.pathname;
  const identifier = inbox.slug || inbox.id;
  return `${base}#/inbox/${identifier}`;
}
